// test1666
(1666 && 0);
